import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../../models/sfcc-basket';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

interface ApplyCouponBody {
  code: string;
}

export const applyCoupon = async (
  couponCode: string,
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  const body: ApplyCouponBody = { code: couponCode };

  return await makeCurrentBasketAction('/coupons', applyCouponToBasket, ensureBasketMethod, body);
};

const applyCouponToBasket = async (
  requestPath: string,
  body: ApplyCouponBody
): Promise<SFCCBasket> => {
  const response = await shopHttp.post<ApplyCouponBody, AxiosResponse<SFCCBasket>>(
    requestPath,
    body
  );

  return response.data;
};
